module.exports = __webpack_public_path__ + "img/Logo_light.19cdf5f7.svg";